import { render, staticRenderFns } from "./CompaniesView.vue?vue&type=template&id=fca2ab4c&scoped=true"
import script from "./CompaniesView.vue?vue&type=script&lang=js"
export * from "./CompaniesView.vue?vue&type=script&lang=js"
import style0 from "./CompaniesView.vue?vue&type=style&index=0&id=fca2ab4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca2ab4c",
  null
  
)

export default component.exports